import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

import {withConfig, withI18n} from 'spa/Components/Context';

import './social-media-icons.less';

@inject(({
  store: {
    navigation: {
      footer: {
        socials,
      },
    },
  },
}) => (
  {
    socials,
  }
))
@observer
@withI18n
@withConfig
class SocialLinks extends React.Component {
  static propTypes = {
    socials: PropTypes.object.isRequired,
  };

  @computed get socialLinks() {
    const { socials } = this.props;
    return socials.map(social => (
      <a
        href={social.url}
        className="social-media-icon"
        target="_blank"
        rel="noopener noreferrer"
        key={social.name.toLowerCase()}
      >
        <img src={social.icon} alt={social.name} />
      </a>
    ));
  }

  render() {
    const {
      socialLinks,
    } = this;

    return (
      <div className="social-media-container">
        {socialLinks}
      </div>
    );
  }
}

export default SocialLinks;



// WEBPACK FOOTER //
// ./spa/Components/Footer/SocialLinks.jsx